// pages/whatsapp/Settings.jsx
import React from 'react';
import { MDBIcon } from 'mdb-react-ui-kit';

const WhatsAppSettings = () => {
  return (
    <div>
      <h2 className="mb-4">
        <MDBIcon icon="cog" className="me-2" />
        WhatsApp Settings
      </h2>
      <p>Configure your WhatsApp settings.</p>
    </div>
  );
};

export default WhatsAppSettings;